// eslint-disable-next-line import/no-cycle
import { $http } from "@/assets/js/appFunc";

export const serviceProvider = () => {
    const req = {
        type: "GET",
        url: "/identity/authRealm/config/default"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getConfigUrls = () => {
    const req = {
        type: "GET",
        url: "/identity/authRealm/config/generate/urls"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const getConfigurations = () => {
    const req = {
        type: "GET",
        url: "/identity/authRealm/configs"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const authConfigActions = (context, payload) => {
    const url = "/identity/authRealm/config";
    const req = {
        type: "POST",
        url,
        data: payload
    };
    return $http(req, true);
};

export const authConfigActivation = (context, payload) => {
    const url = "/identity/authRealm/config/activation";
    const req = {
        type: "POST",
        url,
        data: payload
    };
    return $http(req, true);
};

export const authConfigDelete = (context, payload) => {
    const url = "/identity/authRealm/config/delete";
    const req = {
        type: "POST",
        url,
        data: payload
    };
    return $http(req, true);
};

export const metadataXML = (context, filename) => {
    const req = {
        type: "GET",
        url: `/identity/saml/config/download/XML/${filename}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const LDAPStatus = () => {
    const req = {
        type: "GET",
        url: "/identity/saml/config/ldap-status"
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const generateCode = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/auth/tenants/two-factor/send-code",
        data: payload,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};

export const twoFactorCode = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/auth/login/2fa",
        data: payload,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};
export const validateCode = (context, payload) => {
    const req = {
        type: "POST",
        url: "/identity/public/users/two-factor/set-user",
        data: payload,
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data);
            },
            error => {
                reject(error);
            }
        );
    });
};
